export const ID = '106BDAW6O3'
export const KEY = '37badabedd45dadc12150eff8d1ce9a5'

export const KEYWRITE = 'ec0cd76c1b333d569c328fe888d48115'